import React, { useContext } from 'react';
import TestQuestions from '../organisms/TestQuestions'
import { StateController } from './../../App'

function FeedbackBlock() {
  const {context} = useContext(StateController)
//   const remaining = maxChars - text.length;
  return (
    <section className="feedback" aria-labelledby="feedback-title">
        { context && context.quiz && (context.quiz.length === 0 || context.quiz.every(q => q.response_1 === null)) &&
          <div className="feedback__inner">
              <div className='mc-section-testForm'>
                <TestQuestions context={context} quizNumber={1} />
              </div>
              <div className="feedback__left">
                <div className="feedback__card">
                  <img
                    src="/assets/images/card-logito.png"
                    alt="Tarjeta Éxito"
                    className="feedback__cardImg solo-exito"
                    loading="lazy"
                  />

                  <img
                    src="/assets/images/cate2.png"
                    alt="Tarjeta Éxito"
                    className="feedback__cardImg solo-carulla"
                    loading="lazy"
                  />
                </div>
              </div>
          </div>
        }
    </section>
  );
}

export default FeedbackBlock;
